const { authComponentEvents } = require('./componentPath/auth');
const { addBeneComponentEvents } = require('./componentPath/addBene');
const {
  addBeneficiaryApplicationComponentEvents
} = require('./componentPath/addBeneficiaryApplication');
const { commonComponentEvents } = require('./componentPath/common');
const { onboardingComponentEvents } = require('./componentPath/onboarding');
const {
  onboardingApplicationComponentEvents
} = require('./componentPath/onboardingApplication');
const {
  interestQuestionnaireComponentEvents
} = require('./componentPath/studentServices/interestQuestionnaire');
const {
  rewardsPageEvents
} = require('./componentPath/studentServices/rewardsPage');
const { contributionComponentEvents } = require('./componentPath/contribution');
const {
  careerAndSchoolMatcherComponentEvents
} = require('./componentPath/studentServices/careerAndSchoolMatcher');
const {
  StudentServicesHomepageComponentEvents
} = require('./componentPath/studentServices/studentServicesHomepage');
const {
  SendAGiftComponentEvents
} = require('./componentPath/studentServices/sendAGift');
const {
  giftingComponentEvents
} = require('./componentPath/studentServices/gifting');
const {
  costOfSchoolComponentEvents
} = require('./componentPath/studentServices/costOfSchool');
const { valuePropTourEvents } = require('./componentPath/valuePropTour');
const {
  coSubReminderComponentEvents
} = require('./componentPath/coSubReminder');
const {
  loginOfferComponentEvents
} = require('./componentPath/studentServices/loginOfferDialog');
const { promoOfferComponentEvents } = require('./componentPath/promoOffer');
const {
  postOnboardingSurveyEvents
} = require('./componentPath/postOnboardingSurvey');
const {
  transferInApplicationComponentEvents
} = require('./componentPath/transferInApplication');
const {
  withdrawalApplicationComponentEvents
} = require('./componentPath/withdrawalApplication');
const {
  aipWithdrawalApplicationComponentEvents
} = require('./componentPath/aipWithdrawal');
const {
  respDashboardEvents
} = require('./componentPath/studentServices/respDashboard');
const {
  nonRespDashboardEvents
} = require('./componentPath/studentServices/nonRespDashboard');
const {
  oldRespDashboardCompnentEvents
} = require('./componentPath/oldRespDashboard');
const { referFriendComponentEvents } = require('./componentPath/referFriend');
const {
  expectingParentEvents
} = require('./componentPath/studentServices/expectingParent');
const {
  expectingParentApplicationComponentEvents
} = require('./componentPath/expectingParent');
const {
  ScheduledContributionsComponentEvents
} = require('./componentPath/scheduledContributions');
const {
  PlanSpecificDashboardComponentEvents
} = require('./componentPath/planSpecificDashboard');
const {
  DashboardPortfolioComponentEvents
} = require('./componentPath/portfolioDetails');
const { genesysChatComponentEvents } = require('./componentPath/genesysChat');
const {
  messageCenterComponentEvents
} = require('./componentPath/messageCenter');
const { PlaidAndFlinksEvents } = require('./componentPath/plaidAndFlinks');

const { AzureAuthenticate } = authComponentEvents;

const {
  AddBenePlanSelect,
  AddBenePlanSelectError,
  AddBeneReview,
  AddBeneSuccess
} = addBeneficiaryApplicationComponentEvents;

const {
  BrowserError,
  PhoneTextField,
  PersonalInfo,
  PlanSelect,
  ChildDetailsForm,
  BillPayment
} = commonComponentEvents;

const {
  MessageInbox,
  MessageView,
  NewMessage,
  MessageSuccess,
  MessageFail,
  NoWithdrawCase,
  NoTransferCase,
  ClosedMessage
} = messageCenterComponentEvents;

const {
  Onboarding,
  OnboardingPlanType,
  OnboardingBeneficiaries,
  OnboardingCoApplicant,
  OnboardingIPSQuestion,
  OnboardingRiskProfile,
  OnboardingNewGrants,
  OnboardingSIN,
  OnboardingBeneficiarySIN,
  OnboardingReview,
  OnboardingTermsAndCondition,
  OnboardingSuccess,
  OnboardingCalculator
} = onboardingComponentEvents;

const {
  CosubscriberRelationship,
  CosubOnboardingSuccess,
  PlanType,
  ChildDetails,
  SetReminder,
  Calculation,
  FreePromotion,
  EmploymentAndMarital,
  IncomeAndDependents,
  LiabilitiesAndAssets,
  AlmostThere,
  InvestmentExperience,
  IPSQuestions,
  RiskProfile,
  ConservativePlanNotice,
  Grants,
  IDVGateway,
  IDVerification,
  SubscriberInfo,
  SubscriberSIN,
  BeneficiarySIN,
  ApplicationReview,
  TermsAndConditions,
  Success,
  UnderReview,
  CannotContinue
} = onboardingApplicationComponentEvents;

const {
  WithdrawalSuccess,
  WithdrawalVOE,
  WithdrawalSampleVOE,
  WithdrawalAmount
} = withdrawalApplicationComponentEvents;

const {
  ContributionDetails,
  VerifyContribution,
  ContributionSuccess,
  PACSuccess
} = contributionComponentEvents;

const {
  InterestQuestionnaireEntry,
  InterestQuestionnaireAttributeQuiz,
  InterestQuestionnaireEmail,
  InterestQuestionnaireCareers
} = interestQuestionnaireComponentEvents;

const { Rewards, CslOfferDialog } = rewardsPageEvents;

const {
  RespHome,
  Plans,
  Money: RespMoney,
  Rewards: RespRewards,
  Settings: RespSettings,
  RemindCoSubDialog,
  Documents: RespDocuments,
  AddChildOfferCard,
  AddChildOfferDialog,
  BillPaymentDialog,
  NavigationMenu
} = respDashboardEvents;

const { ReferFriendLanding } = referFriendComponentEvents;

const { OldRespDashboard } = oldRespDashboardCompnentEvents;

const {
  Dashboard: NonRespDashboard,
  ChildSavingsCalculatorFilters,
  Money: NonRespMoney,
  Rewards: NonRespRewards,
  Settings: NonRespSettings,
  Tools: NonRespTools,
  PrenatalDashboard
} = nonRespDashboardEvents;

const { CosubDialog, CoSubInviteCard, ChildProfile, FeatureCard, GiftNoRESP } =
  StudentServicesHomepageComponentEvents;

const { PickProfessions, ProgramMatcherMap, ProgramMatcherResult, CareerList } =
  careerAndSchoolMatcherComponentEvents;

const {
  SendAGiftEntry,
  SendAGiftSelectPlan,
  SendAGiftSelectBene,
  SendAGiftBeneEmail,
  SendAGiftShare
} = SendAGiftComponentEvents;

const {
  GiftingOccasions,
  GiftingAmount,
  GiftingRelationship,
  GiftingReview,
  GiftingSuccess
} = giftingComponentEvents;

const {
  CostOfSchoolFromHomepage,
  CostOfSchoolEntry,
  CostOfSchoolFromDigitalDashboard,
  CostOfSchoolBeneficiaryProfile,
  CostOfSchoolMyFutureScholar,
  CostOfSchoolCustomize,
  CostOfSchoolEducationGoal
} = costOfSchoolComponentEvents;

const { RemindCoSubDialogLoad, RemindCoSubBanner, RemindCoSubRegistration } =
  coSubReminderComponentEvents;

const { NewUnifiedFlow } = valuePropTourEvents;

const { loginOfferDialog } = loginOfferComponentEvents;

const { promoOfferDialog } = promoOfferComponentEvents;

const { POSurvey } = postOnboardingSurveyEvents;

const {
  TransferInTermsAndConditions,
  TransferInPlanSelect,
  TransferInDetails,
  TransferInAmount,
  TransferInReview,
  TransferInDownloadForm,
  TransferInInstructions
} = transferInApplicationComponentEvents;

const {
  WithdrawalGateway,
  AIPWithdrawalPlanSelection,
  AIPWithdrawalBalance,
  AIPJointAccountWithdrawal,
  AIPWithdrawalBankSelect,
  AIPDeductionLimitRRSP,
  AIPWithdrawalTransferDetails,
  AIPWithdrawalReview,
  AIPWithdrawalSuccess
} = aipWithdrawalApplicationComponentEvents;

const {
  SetADueDate,
  ReviewPage: ExpectingParentReviewPage,
  SuccessPage: ExpectingParentSuccessPage
} = expectingParentEvents;

const {
  Calculation: ExpectingParentCalculation,
  FreePromotion: ExpectingParentFreePromotion,
  EmploymentAndMarital: ExpectingParentEmploymentStatusAndMarital,
  IncomeAndDependents: ExpectingParentIncomeAndDependents,
  LiabilitiesAndAssets: ExpectingParentLiabilitiesAndAssets,
  InvestmentExperience: ExpectingParentInvestmentExperience,
  IPSQuestions: ExpectingParentIPSQuestions,
  RiskProfile: ExpectingParentRiskProfile,
  ConservativePlanNotice: ExpectingParentConservativePlanNotice,
  IDVGateway: ExpectingParentIDVGateway,
  IDVerification: ExpectingParentIDVerification,
  IDVFAQ: ExpectingParentIDVFAQ,
  SubscriberInfo: ExpectingParentSubscriberInfo,
  Grants: ExpectingParentGrants,
  SubscriberSIN: ExpectingParentSubscriberSIN,
  ApplicationReview: ExpectingParentApplicationReview,
  Success: ExpectingParentSuccess,
  Error: ExpectingParentError
} = expectingParentApplicationComponentEvents;

const { ScheduledContributions } = ScheduledContributionsComponentEvents;

const { PlanSpecificDashboard } = PlanSpecificDashboardComponentEvents;

const { DashboardPortfolio } = DashboardPortfolioComponentEvents;

const { MessengerOpened, MessengerClosed } = genesysChatComponentEvents;

const { AddBankAccountConsentIntercept } = PlaidAndFlinksEvents;

module.exports = {
  componentEvents: {
    '<ComponentName>': {
      code: '<Code used for Component',
      events: {
        '<eventName>': {
          discription: '<Optional description to define the event>',
          eventHub: {
            code: '<eventHub Code for the event>',
            action:
              '<eventHub action text with [$.<optional.data.path>] which will get replace at runtime>',
            dataKeys: [
              'optional',
              'list',
              'of',
              'data',
              'elements',
              'to',
              'be',
              'sent',
              'along',
              'with',
              'evnet'
            ]
          },
          ga: {
            action:
              '<Action text for Google Analytics with [$.<optional.data.path>] which will get replace at runtime'
          }
        }
      }
    },
    BrowserError,
    AzureAuthenticate,
    AddBenePlanSelect,
    AddBenePlanSelectError,
    AddBeneReview,
    AddBeneSuccess,
    PhoneTextField,
    PersonalInfo,
    PlanSelect,
    BillPayment,
    ChildDetailsForm,
    Onboarding,
    OnboardingPlanType,
    OnboardingBeneficiaries,
    OnboardingCoApplicant,
    OnboardingIPSQuestion,
    OnboardingRiskProfile,
    OnboardingNewGrants,
    OnboardingSIN,
    OnboardingBeneficiarySIN,
    OnboardingReview,
    OnboardingTermsAndCondition,
    OnboardingSuccess,
    OnboardingCalculator,
    CannotContinue,
    WithdrawalSuccess,
    InterestQuestionnaireEntry,
    InterestQuestionnaireAttributeQuiz,
    InterestQuestionnaireEmail,
    InterestQuestionnaireCareers,
    Rewards,
    CslOfferDialog,
    RespHome,
    Plans,
    RespMoney,
    RespRewards,
    RespSettings,
    RespDocuments,
    RemindCoSubDialog,
    AddChildOfferCard,
    AddChildOfferDialog,
    NonRespDashboard,
    ChildSavingsCalculatorFilters,
    NonRespMoney,
    NonRespRewards,
    NonRespSettings,
    NonRespTools,
    PrenatalDashboard,
    ContributionDetails,
    VerifyContribution,
    ContributionSuccess,
    CosubDialog,
    CoSubInviteCard,
    ChildProfile,
    PickProfessions,
    ProgramMatcherMap,
    CareerList,
    FeatureCard,
    GiftNoRESP,
    RemindCoSubRegistration,
    RemindCoSubDialogLoad,
    RemindCoSubBanner,
    SendAGiftEntry,
    SendAGiftSelectPlan,
    SendAGiftSelectBene,
    SendAGiftBeneEmail,
    SendAGiftShare,
    GiftingOccasions,
    GiftingAmount,
    GiftingRelationship,
    GiftingReview,
    GiftingSuccess,
    ProgramMatcherResult,
    CostOfSchoolFromHomepage,
    CostOfSchoolEntry,
    CostOfSchoolFromDigitalDashboard,
    CostOfSchoolBeneficiaryProfile,
    CostOfSchoolMyFutureScholar,
    CostOfSchoolCustomize,
    CostOfSchoolEducationGoal,
    NewUnifiedFlow,
    CosubscriberRelationship,
    CosubOnboardingSuccess,
    PlanType,
    ChildDetails,
    SetReminder,
    Calculation,
    FreePromotion,
    EmploymentAndMarital,
    IncomeAndDependents,
    LiabilitiesAndAssets,
    AlmostThere,
    InvestmentExperience,
    IPSQuestions,
    RiskProfile,
    ConservativePlanNotice,
    Grants,
    IDVGateway,
    IDVerification,
    SubscriberInfo,
    SubscriberSIN,
    BeneficiarySIN,
    ApplicationReview,
    TermsAndConditions,
    Success,
    UnderReview,
    loginOfferDialog,
    promoOfferDialog,
    POSurvey,
    PACSuccess,
    TransferInTermsAndConditions,
    TransferInPlanSelect,
    TransferInDetails,
    TransferInAmount,
    TransferInReview,
    TransferInDownloadForm,
    TransferInInstructions,
    WithdrawalGateway,
    AIPWithdrawalPlanSelection,
    AIPWithdrawalBalance,
    AIPJointAccountWithdrawal,
    AIPWithdrawalBankSelect,
    AIPDeductionLimitRRSP,
    AIPWithdrawalTransferDetails,
    AIPWithdrawalReview,
    AIPWithdrawalSuccess,
    WithdrawalVOE,
    WithdrawalSampleVOE,
    WithdrawalAmount,
    SetADueDate,
    ExpectingParentCalculation,
    ExpectingParentFreePromotion,
    ExpectingParentEmploymentStatusAndMarital,
    ExpectingParentIncomeAndDependents,
    ExpectingParentLiabilitiesAndAssets,
    ExpectingParentInvestmentExperience,
    ExpectingParentIPSQuestions,
    ExpectingParentRiskProfile,
    ExpectingParentConservativePlanNotice,
    ExpectingParentIDVFAQ,
    ExpectingParentSubscriberInfo,
    ExpectingParentGrants,
    ExpectingParentSubscriberSIN,
    ExpectingParentApplicationReview,
    ExpectingParentSuccess,
    ExpectingParentError,
    ExpectingParentReviewPage,
    ExpectingParentSuccessPage,
    ExpectingParentIDVGateway,
    ExpectingParentIDVerification,
    ScheduledContributions,
    ReferFriendLanding,
    OldRespDashboard,
    PlanSpecificDashboard,
    DashboardPortfolio,
    MessengerOpened,
    MessengerClosed,
    BillPaymentDialog,
    MessageInbox,
    MessageView,
    NewMessage,
    MessageSuccess,
    MessageFail,
    NoWithdrawCase,
    NoTransferCase,
    ClosedMessage,
    NavigationMenu,
    AddBankAccountConsentIntercept
  }
};
